
class Vec3
{
    public x : number;
    public y : number;
    public z : number;

    constructor( x:number, y:number, z:number )
    {
        this.x = x;
        this.y = y;
        this.z = z;
    }
}

export default Vec3;